'use client';

import { useParams } from 'next/navigation';
import { Locale } from '@/lib/i18n/config';
import { toLocalizedNumerals, localizeNumbersInText } from '@/lib/utils/numberConverter';

/**
 * Hook for converting numbers to locale-specific numerals
 */
export function useLocalizedNumbers() {
  const params = useParams();
  const locale = (params?.locale as Locale) || 'en';

  /**
   * Convert a number or string to localized numerals
   */
  const localizeNumber = (input: string | number): string => {
    return toLocalizedNumerals(input, locale);
  };

  /**
   * Convert numbers within text to localized numerals
   */
  const localizeText = (text: string): string => {
    return localizeNumbersInText(text, locale);
  };

  /**
   * Check if current locale uses RTL numerals
   */
  const usesLocalizedNumerals = (): boolean => {
    return locale === 'ar' || locale === 'fa';
  };

  return {
    localizeNumber,
    localizeText,
    usesLocalizedNumerals,
    locale
  };
}